import { useState } from 'react';
import { getMenuNote, setMenuNote } from '../lib/menuNotes';

interface SavedMenuNoteProps {
  menuId: string;
}

// Inline editable note attached to a saved menu row. Tap to add/edit; blur
// to save. Self-managed local state — no parent prop drilling beyond the
// menuId. Stored in localStorage via menuNotes.ts.
export function SavedMenuNote({ menuId }: SavedMenuNoteProps) {
  const [note, setNote] = useState(() => getMenuNote(menuId));
  const [editing, setEditing] = useState(false);

  const save = (text: string) => {
    setMenuNote(menuId, text);
    setNote(text.trim());
    setEditing(false);
  };

  if (editing) {
    return (
      <textarea
        autoFocus
        defaultValue={note}
        onBlur={(e) => save(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setEditing(false);
          }
        }}
        placeholder="What happened here? Visible only to you."
        rows={2}
        style={{
          width: '100%',
          marginTop: 8,
          padding: '8px 10px',
          borderRadius: 8,
          border: '1px solid var(--color-divider)',
          background: 'var(--color-bg)',
          color: 'var(--color-primary)',
          fontSize: 13,
          lineHeight: 1.4,
          resize: 'vertical',
          fontFamily: 'inherit',
        }}
      />
    );
  }

  if (note) {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setEditing(true);
        }}
        style={{
          marginTop: 8,
          padding: '6px 10px',
          background: 'transparent',
          border: 'none',
          borderLeft: '2px solid var(--color-divider)',
          color: 'var(--color-text-secondary)',
          fontSize: 12,
          fontStyle: 'italic',
          textAlign: 'left',
          width: '100%',
          lineHeight: 1.4,
          cursor: 'pointer',
        }}
      >
        {note}
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setEditing(true);
      }}
      style={{
        marginTop: 8,
        padding: '4px 0',
        background: 'transparent',
        border: 'none',
        color: 'var(--color-text-secondary)',
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
      }}
    >
      + Add note
    </button>
  );
}
